import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { TorPreviewDocument } from "@/components/governance/TorPreviewDocument";
import { useGovernance } from "@/hooks/useGovernance";

export default function TorPreview() {
  const { committeeId } = useParams();
  const { committees, terms, members } = useGovernance();

  const committee = committees.find((item) => item.id === committeeId);
  const tor = terms.find((item) => item.committeeId === committeeId);

  if (!committee || !tor) {
    return (
      <Card className="shadow-card">
        <CardContent className="py-16 text-center text-muted-foreground">
          ToR preview is not available.
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <Link to={`/governance/tor/${committee.id}`}>
          <Button variant="outline">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Editor
          </Button>
        </Link>
      </div>

      <TorPreviewDocument committee={committee} tor={tor} members={members} />
    </div>
  );
}
